import { Keys, QuestionKey } from '@hb/modules/global/global.constants';
import { GlobalControl } from '@hb/domain/controls/global-control';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';

import { Validators } from '@angular/forms';

export class AmountFormControl<T> extends GlobalControl<T> {
    resetControl(key: QuestionKey): void {
        this.reset();
        this.addValidators([
            Validators.required,
            Validators.min(Keys.getValidationAmount(key, 'min')),
            Validators.max(Keys.getValidationAmount(key, 'max'))
        ]);
    }

    constructor(
        readonly analyticsService: AnalyticsService,
        state: T,
        key: QuestionKey
    ) {
        super(analyticsService, key, state);
        this.addValidators([
            Validators.required,
            Validators.min(Keys.getValidationAmount(key, 'min')),
            Validators.max(Keys.getValidationAmount(key, 'max'))
        ]);
    }
}
